/*
 * @Descripttion: 常量
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
export default {
  // 短信通道退订文案
  Tab_List: [
    {
      label: '近1天',
      value: 1,
    },
    {
      label: '近3天',
      value: 3,
    },
    {
      label: '近5天',
      value: 5,
    },
    {
      label: '近7天',
      value: 7,
    },
  ],
  ROI: 'ROI=成交金额/（实际触达人数*短信单价）',
  cost: '营销成本=实际触达人数*短信单价',
  earnings: '营销收益=成交金额',
  sendRate: '触达率=实际触达人数/预计触达人数*100%',
  recallUserCntRate: '访问率=访问人数/实际触达人数*100%',
  kedan: '客单价=成家金额/成交人数',
  fangwenzhuanhua: '访问转化率=成交人数/访问人数*100%（目前平台仅提供24h的访问数据，因此仅有24h访问转化率的数据）',
  chudazhuanhua: '触达转化率=成交人数/触达人数*100%',
}
